import { render, staticRenderFns } from "./DropList.vue?vue&type=template&id=be4477c0&"
import script from "./DropList.vue?vue&type=script&lang=js&"
export * from "./DropList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports